angular.module("KhSidebar").factory("SideNavFactory", ["$resource", function ($resource) {
    return $resource('/api/v1.0/config/apps/', {}, {
        get: {
            method: 'GET'
        }
    });
}]);